export default __webpack_public_path__ + "static/media/arrow_right.d6d6c4d8.svg";